import { Country } from "./country";
import { State } from "./state";

export class City {
    city_name:string;
    country: Country;
    state: State    
}
